import { render } from "./sidecut.vue?vue&type=template&id=151c3935&scoped=true"
import script from "./sidecut.vue?vue&type=script&lang=js"
export * from "./sidecut.vue?vue&type=script&lang=js"

import "./sidecut.vue?vue&type=style&index=0&id=151c3935&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-151c3935"]])

export default __exports__